"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const trans_1 = require("@common/tsutils/trans");
const MetricRankTag_vue_1 = __importDefault(require("../Results/AreaProjectMap/Components/Metrics/MetricRankTag.vue"));
const BarChart_vue_1 = __importDefault(require("@becrop/components/Common/BarChart.vue"));
const BarChartItem_vue_1 = __importDefault(require("@becrop/components/Common/BarChartItem.vue"));
const ColorLibController_1 = __importDefault(require("../Results/Abstract/Controllers/ColorLibController"));
const project_1 = require("../Results/Abstract/Interfaces/project");
const MapTooltipRecommendationSection_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltipRecommendationSection.vue"));
const Score_1 = __importDefault(require("../Modules/Common/Models/Score"));
const floating_vue_1 = require("floating-vue");
const MapTooltipNeedMapSection_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltipNeedMapSection.vue"));
const BmkLegend_vue_1 = __importDefault(require("./BmkLegend.vue"));
let FieldMapTooltip = class FieldMapTooltip extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.porfolio = [
            {
                name: "P. fluorescens strain A",
                dosis: "7,4%"
            },
            {
                name: "PSB Complex",
                dosis: "9,1%"
            },
            {
                name: "B. bassiana WP",
                dosis: "11,0%"
            },
            {
                name: "Silicium Forte",
                dosis: "2,8%"
            },
            {
                name: "Silicium",
                dosis: "28,8%"
            },
            {
                name: "Forte-F 2",
                dosis: "0,8%"
            }
        ];
        this.colorController = new ColorLibController_1.default();
        this.isMainPanel = true;
        this.selectOption = this.mapSideBarPanel === 'need-maps' ? 'recommendations' : 'chart';
    }
    selectOptionTracker() {
        if (this.mapSideBarPanel === 'need-maps')
            this.selectOption = 'recommendations';
        else
            this.selectOption = 'chart';
    }
    shortenUnit(u) {
        if (u.toLowerCase().charAt(0) === 'h')
            return 'ha';
        if (u.toLowerCase().charAt(0) === 'a')
            return 'ac';
        return u.toLowerCase().charAt(0);
    }
    setOptionPanel(options) {
        this.selectOption = options;
    }
    mainActionClicked() {
        this.$emit('mainActionClicked');
    }
    get hasAdvancedPixelsData() {
        if (this.barChartConfig && this.mapSideBarPanel !== 'need-maps') {
            let totalPercentages = 0;
            this.barChartConfig.forEach((elementConfig) => {
                if (elementConfig.percentage > 0)
                    totalPercentages = +elementConfig.percentage;
            });
            if (totalPercentages > 0)
                return true;
            else
                return false;
        }
        else {
            return false;
        }
    }
    get fieldStats() {
        var _a;
        let statsByDefault = {
            mean: -1,
            min: -1,
            max: -1
        };
        if (!((_a = this.currentGisField) === null || _a === void 0 ? void 0 : _a.needs_maps_results))
            return statsByDefault;
        let needMap = this.currentGisField.needs_maps_results.find(result => this.currentNeedMapCategory.slug.includes(result.category.slug)) || { results: undefined };
        let { stats } = needMap.results || { stats: undefined };
        return stats ? stats : statsByDefault;
    }
    get scoreValue() {
        let tempScore = this.fieldStats.mean;
        if (tempScore < 0)
            return 0;
        tempScore = Math.round(tempScore);
        if (tempScore < 1)
            tempScore = 1;
        if (this.currentNeedMapCategory.typeScale === 'rank') {
            if (this.currentNeedMapCategory.reverseScale) {
                return Math.max(this.currentNeedMapCategory.getCuratedRank(tempScore), 1);
            }
            return tempScore;
        }
        else {
            if (this.currentNeedMapCategory.reverseScale) {
                return Math.max(100 - tempScore, 1);
            }
            return tempScore;
        }
    }
    get metricScale() {
        let scale = 'std';
        if ('baseMetric' in this.currentMetric) {
            if ('scale' in this.currentMetric.baseMetric) {
                scale = this.currentMetric.baseMetric.scale;
            }
        }
        else {
            if ('scale' in this.currentMetric) {
                scale = this.currentMetric.scale;
            }
        }
        return scale;
    }
    get needMapTitle() {
        var _a;
        let titleByDefault = 'Need map not found';
        if (!((_a = this.currentGisField) === null || _a === void 0 ? void 0 : _a.needs_maps_results))
            return titleByDefault;
        let needMap = this.currentGisField.needs_maps_results.find(result => this.currentNeedMapCategory.slug.includes(result.category.slug)) || { category: { title: undefined } };
        return needMap.category.title || titleByDefault;
    }
    get currentGisField() {
        var _a;
        if (!((_a = this.project) === null || _a === void 0 ? void 0 : _a.gisFields))
            return null;
        const field = this.project.gisFields.find((item) => `${item.name}${item.id}` === this.currentFieldName);
        return field;
    }
    get metricUnit() {
        let unit = '';
        if (this.metricScore === -1)
            return '404';
        if ('baseMetric' in this.currentMetric) {
            if ('unit' in this.currentMetric.baseMetric) {
                unit = this.currentMetric.baseMetric.unit;
            }
        }
        else {
            if ('unit' in this.currentMetric) {
                unit = this.currentMetric.unit;
            }
        }
        return unit;
    }
    get metricName() {
        return ('baseMetric' in this.currentMetric) ?
            this.currentMetric.baseMetric.name :
            this.currentMetric.name;
    }
    get metricSurname() {
        return ('baseMetric' in this.currentMetric) ?
            ('test_name' in this.currentMetric.baseMetric) ?
                this.currentMetric.baseMetric.test_name :
                (0, trans_1.trans)('results_view_map.categories.' + this.currentMetric.baseMetric.category)
            :
                ('test_name' in this.currentMetric) ?
                    this.currentMetric.test_name :
                    (0, trans_1.trans)('results_view_map.categories.' + this.currentMetric.category);
    }
    get higherInMain() {
        return ('higherIn' in this.currentMetric) ?
            this.currentMetric.higherIn === 'main' : false;
    }
    get higherInThisPanel() {
        return ('higherIn' in this.currentMetric) ?
            (this.currentMetric.higherIn === 'main' && this.isMainPanel) ||
                (this.currentMetric.higherIn === 'secondary' && !this.isMainPanel) : false;
    }
    get metricScore() {
        let score = 0;
        if (this.type === 'farm') {
            if ('baseMetric' in this.currentMetric) {
                if (this.higherInThisPanel) {
                    if ('scoreBC' in this.currentMetric.baseMetric) {
                        score = this.currentMetric.baseMetric.scoreBC.value;
                    }
                    else {
                        score = Math.round(this.currentMetric.baseMetric.score * 100) / 100;
                    }
                }
                else {
                    score = Math.round(this.currentMetric.scoreDefeated.value * 100) / 100;
                }
            }
            else {
                //console.log('simple')
                if ('scoreBC' in this.currentMetric) {
                    //console.log('bio')
                    score = this.currentMetric.scoreBC.value;
                }
                else {
                    //console.log('phch')
                    score = Math.round(this.currentMetric.score * 100) / 100;
                }
            }
        }
        else {
            if ('baseMetric' in this.currentMetric) {
                //console.log('vs')
                if (this.higherInThisPanel) {
                    if ('scoreBC' in this.currentMetric.baseMetric) {
                        score = this.currentMetric.baseMetric.scoreBC.value;
                    }
                    else {
                        score = Math.round(this.currentMetric.baseMetric.score * 100) / 100;
                    }
                }
                else {
                    score = Math.round(this.currentMetric.scoreDefeated.value * 100) / 100;
                }
            }
            else {
                if ('scoreBC' in this.currentMetric) {
                    //console.log('bio')
                    score = this.currentMetric.scoreBC.value;
                }
                else {
                    //console.log('phch')
                    score = Math.round(this.currentMetric.score * 100) / 100;
                }
            }
        }
        if (score < 0)
            score = 0;
        if ('scoreBC' in this.currentMetric) {
            score = new Score_1.default(score, '').value;
        }
        return score;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], FieldMapTooltip.prototype, "scale", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], FieldMapTooltip.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], FieldMapTooltip.prototype, "currentZone", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: project_1.GisField, default: new project_1.GisField({}) })
], FieldMapTooltip.prototype, "currentField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], FieldMapTooltip.prototype, "field", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new project_1.BioMetric({}, {}) })
], FieldMapTooltip.prototype, "currentMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FieldMapTooltip.prototype, "isLoadingOpenReport", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], FieldMapTooltip.prototype, "hasInteraction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FieldMapTooltip.prototype, "hasDownloadableReport", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FieldMapTooltip.prototype, "hasFieldAgInsightForMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], FieldMapTooltip.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], FieldMapTooltip.prototype, "recSet", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], FieldMapTooltip.prototype, "recommendation", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], FieldMapTooltip.prototype, "project", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'need' })
], FieldMapTooltip.prototype, "mapSideBarPanel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FieldMapTooltip.prototype, "showRecommendations", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], FieldMapTooltip.prototype, "recommendationsLength", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FieldMapTooltip.prototype, "baseState", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], FieldMapTooltip.prototype, "currentNeedMapCategory", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], FieldMapTooltip.prototype, "currentFieldName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], FieldMapTooltip.prototype, "barChartConfig", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('mapSideBarPanel')
], FieldMapTooltip.prototype, "selectOptionTracker", null);
FieldMapTooltip = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Button: bmk_ui_framework_1.Button, Tag: bmk_ui_framework_1.Tag, ArrowDown: lucide_vue_next_1.ArrowDown, Separator: bmk_ui_framework_1.Separator, MetricRankTag: MetricRankTag_vue_1.default, BarChart: BarChart_vue_1.default, BarChartItem: BarChartItem_vue_1.default, ScaleLegend: bmk_ui_framework_1.ScaleLegend, MapTooltipRecommendationSection: MapTooltipRecommendationSection_vue_1.default, Info: lucide_vue_next_1.Info, Dropdown: floating_vue_1.Dropdown, MapTooltipNeedMapSection: MapTooltipNeedMapSection_vue_1.default, BmkLegend: BmkLegend_vue_1.default }
    })
], FieldMapTooltip);
exports.default = FieldMapTooltip;
